
import { useOutletContext } from "react-router-dom";
import AccountSettings from "./components/AccountSettings";
import ProfileCard from "./components/ProfileCard";
import ProfileHeader from "./components/ProfileHeader";
import StatsCard from "./components/StatsCard";
import "./profile.css";

const ProfilePage = () => {
   const { openSidebar } = useOutletContext();
  return (
    <>
    <div className="profile-page">
      <ProfileHeader onMenuClick={openSidebar}/>
      <div className="profile-layout">
        <div className="left-section">
          <ProfileCard />
          <div className="profile-footer">
            <StatsCard
            title="Total Commission"
            amount="₹42,500"
            footer="+14% this month"
            type="success"
          />
          <StatsCard
            title="Pending Payout"
            amount="₹8,200"
            footer="Next: 15 Feb"
            type="info"
          />
          </div>
        </div>

        <div className="right-section">
          <AccountSettings />
        </div>
      </div>
    </div>
    </>
  );
};

export default ProfilePage;
